/**
 * SA-1029 (spec §D18, §D19): who is told about a customer update, and how.
 * The interest rule is client-side by ruling: every event reaches every
 * browser, this decides. Seat membership compares ROLE NAMES, the server's
 * own rule (`process_task_access.holds_seat`); an open seat (no roles)
 * contributes nothing here, or everyone would be interested.
 */
export interface UpdateInterest {
  ownerId: string | null
  assignedTo: string | null
  seatRoles: string[]
}

export type NoticeTarget = 'record' | 'task' | 'elsewhere'

export function isInterested(viewer: { id: string; roles: string[] } | null, interest: UpdateInterest | undefined): boolean {
  if (!viewer || !interest) return false
  if (interest.ownerId !== null && interest.ownerId === viewer.id) return true
  if (interest.assignedTo !== null && interest.assignedTo === viewer.id) return true
  return interest.seatRoles.some((role) => viewer.roles.includes(role))
}

/** Where the viewer is, by the URL: on that record, on one of its tasks, or elsewhere. */
export function noticeTarget(location: { pathname: string; search: string }, orderId: string, taskOrderId: string | null): NoticeTarget {
  if (location.pathname === '/orders' && new URLSearchParams(location.search).get('order') === orderId) return 'record'
  if (location.pathname.startsWith('/tasks/') && taskOrderId === orderId) return 'task'
  return 'elsewhere'
}
